import Full from '@rebuild/materials/shared/announcement/FullIndex.vue';
import MobPure from './mob-pure.vue';

export const componentMap = {
	pure: Full,
	'mob-pure': MobPure
};
